module.exports = __webpack_public_path__ + "img/tools.0bdfebed.svg";